import React, { useState } from 'react'
import { Breadcrumb, Layout } from 'antd'
import { Content } from 'antd/lib/layout/layout'
import {
  CardContainer,
  FormDropDown,
  FormInput,
  HeaderContainer,
  Loading,
  ModalDelete,
  Table
} from 'components'
import { Formik } from 'formik'
import { IcEdit, IcTrash } from 'assets/icons'
import { ModalCreateUpdateLocation } from './components'
import { useDispatch, useSelector } from 'react-redux'
import { useQuery } from 'react-query'
import { apiDelete, apiGet, apiPost, apiPut, urls } from 'api'
import { metaInitialData, perPageInitialData } from 'constant'
import { logout } from 'store/actions'

const LocationPage = () => {
  const dispatch = useDispatch()
  const user = useSelector((state) => state.auth)
  const [listLocations, setListLocations] = useState()
  const [meta, setMeta] = useState(metaInitialData)
  const [currentPage, setCurrentPage] = useState(0)
  const [perPageArr, setPerPageArr] = useState(perPageInitialData)
  const [dropDownProvince, setDropDownProvince] = useState([])
  const [dropDownCity, setDropDownCity] = useState([])
  const [dropDownSubDistrict, setDropDownSubDistrict] = useState([])

  const onLogout = () => dispatch(logout())

  const { isLoading, refetch } = useQuery({
    queryKey: ['locations'],
    refetchOnWindowFocus: false,
    queryFn: async () =>
      await Promise.all([
        apiGet({
          url: `${urls.master.prefix}/${urls.master.location.all.root}?limit=${
            perPageArr.find((item) => item.selected === true).value
          }&offset=0`,
          token: user.token,
          onLogout
        }),
        apiGet({
          url: `${urls.master.prefix}/${urls.master.location.province.all}`,
          token: user.token,
          onLogout
        })
        // apiGet({
        //   url: `${urls.master.prefix}/${urls.master.location.cities.all}`,
        //   token: user.token,
        //   onLogout
        // }),
        // apiGet({
        //   url: `${urls.master.prefix}/${urls.master.location.subDistrict.all}`,
        //   token: user.token,
        //   onLogout
        // })
      ]),
    onSuccess: (data) => {
      setDropDownProvince([])
      setDropDownCity([])
      setDropDownSubDistrict([])
      setListLocations(data[0].resData.data)
      setCurrentPage(0)
      setMeta(data[0].resData.meta)
      if (data[1].resStatus === 200) {
        if (data[1].resData.data.length !== 0) {
          data[1].resData.data.map((item) => {
            setDropDownProvince((prev) => [...prev, { name: item.name, value: item.id }])
          })
        }
      }
      // if (data[2].resStatus === 200) {
      //   if (data[2].resData.data.length !== 0) {
      //     data[2].resData.data.map((item) => {
      //       setDropDownCity((prev) => [...prev, { name: item.name, value: item.id }])
      //     })
      //   }
      // }
      // if (data[3].resStatus === 200) {
      //   if (data[3].resData.data.length !== 0) {
      //     data[3].resData.data.map((item) => {
      //       setDropDownSubDistrict((prev) => [...prev, { name: item.name, value: item.id }])
      //     })
      //   }
      // }
    }
  })

  const [modalDelete, setModalDelete] = useState({
    show: false,
    locationId: 0,
    title: '',
    desc: ''
  })

  const [modalCreateUpdate, setModalCreateUpdate] = useState({
    show: false,
    type: 'create',
    id: 0,
    name: '',
    postalCode: '',
    provinceId: 0,
    cityId: 0,
    subDistrictId: 0
  })

  const [isLoadingCRUD, setIsLoadingCRUD] = useState(false)
  const [provinceSelected, setProvinceSelected] = useState()
  const [citySelected, setCitySelected] = useState()
  const [subDistrictSelected, setSubDistrictSelected] = useState()
  const [locationSearch, setLocationSearch] = useState('')

  const onHandleExtraUrl = () => {
    let extraUrl = ''

    if (locationSearch !== '') {
      extraUrl += `&keywords=${locationSearch}`
    }
    if (provinceSelected && provinceSelected > 0) {
      extraUrl += `&province_id=${provinceSelected}`
    }
    if (citySelected && citySelected > 0) {
      extraUrl += `&city_id=${citySelected}`
    }
    if (subDistrictSelected && subDistrictSelected) {
      extraUrl += `&subdistrict_id=${subDistrictSelected}`
    }
    return extraUrl
  }

  const onChangePrevNextPage = (offset) => {
    setIsLoadingCRUD(true)
    setMeta({ ...meta, offset })
    const mount = setTimeout(async () => {
      const response = await apiGet({
        url: `${urls.master.prefix}/${urls.master.location.all.root}?limit=${
          perPageArr.find((item) => item.selected === true).value
        }&offset=${offset}${onHandleExtraUrl()}`,
        token: user.token,
        onLogout
      })
      if (response.resStatus === 200 && response.resData.meta.http_code === 200) {
        setListLocations(response.resData.data)
      } else {
        refetch()
      }
      setIsLoadingCRUD(false)
    })
    return () => clearTimeout(mount)
  }

  const onChangePerPage = (value) => {
    setIsLoadingCRUD(true)
    const newArr = [...perPageArr]
    newArr.map((item) => {
      if (item.value === value) {
        item.selected = true
      } else {
        item.selected = false
      }
    })
    const mount = setTimeout(async () => {
      const response = await apiGet({
        url: `${urls.master.prefix}/${
          urls.master.location.all.root
        }?limit=${value}&offset=0${onHandleExtraUrl()}`,
        token: user.token,
        onLogout
      })
      if (response.resStatus === 200 && response.resData.meta.http_code === 200) {
        setListLocations(response.resData.data)
        setMeta(response.resData.meta)
        setPerPageArr(newArr)
      } else {
        refetch()
      }
      setIsLoadingCRUD(false)
    })
    return () => clearTimeout(mount)
  }

  const columns = [
    {
      name: 'Provinsi',
      selector: (row) => row.province_name,
      cell: (row) => <span className="font-medium text-gray-700">{row.province_name}</span>
    },
    {
      name: 'Kota/Kabupaten',
      selector: (row) => row.city_name,
      cell: (row) => <span className="font-medium text-gray-700">{row.city_name}</span>
    },
    {
      name: 'Kecamatan',
      selector: (row) => row.subdistrict_name,
      cell: (row) => <span className="font-medium text-gray-700">{row.subdistrict_name}</span>
    },
    {
      name: 'Keluarahan/Desa',
      selector: (row) => row.name,
      cell: (row) => <span className="font-medium text-gray-700">{row.name}</span>
    },
    {
      name: 'Kode Pos',
      selector: (row) => row.postal_code,
      cell: (row) => <span className="font-medium text-gray-700">{row.postal_code}</span>
    },
    {
      name: 'Action',
      button: true,
      ignoreRowClick: true,
      sortable: false,
      right: true,
      center: true,
      width: '100px',
      cell: (row) => (
        <div className="flex items-center justify-center self-center">
          <div
            className="hover:cursor-pointer p-1 border-solid border border-gray-300 rounded-md mr-2 hover:bg-gray-100"
            onClick={() =>
              setModalCreateUpdate({
                show: true,
                type: 'update',
                id: row.id,
                name: row.name,
                postalCode: row.postal_code,
                provinceId: row.province_id,
                cityId: row.city_id,
                subDistrictId: row.subdistrict_id
              })
            }>
            <IcEdit className="text-gray-700" size={16} />
          </div>
          <div
            className="hover:cursor-pointer p-1 border-solid border border-[#FDA19B] rounded-md hover:bg-gray-100"
            onClick={() =>
              setModalDelete({
                show: true,
                locationId: row.id,
                title: 'Hapus Lokasi',
                desc: `Apakah anda yakin ingin menghapus lokasi [${`Kel. ${row.name}`}, ${`Kec. ${row.subdistrict_name}`}, ${`Kota ${row.city_name}`}, ${
                  row.province_name
                } ${row.postal_code}] ini? Data yang Anda Hapus tidak dapat dipulihkan kembali.`
              })
            }>
            <IcTrash className="text-primary-500" size={16} />
          </div>
        </div>
      )
    }
  ]

  if (isLoading ?? isLoadingCRUD) {
    return <Loading visible={true} />
  }

  return (
    <Layout style={{ padding: 24, background: '#F5F5F5', width: '100%' }}>
      <Breadcrumb style={{ margin: 8 }}>
        <Breadcrumb.Item className="font-inter font-semibold text-gray-700">
          Master Data
        </Breadcrumb.Item>
        <Breadcrumb.Item className="font-inter font-medium text-gray-500">Lokasi</Breadcrumb.Item>
        <Breadcrumb.Item className="font-inter font-medium text-gray-500">
          Lokasi Lengkap
        </Breadcrumb.Item>
      </Breadcrumb>
      <Content style={{ margin: 8 }}>
        {modalCreateUpdate.show ? (
          <ModalCreateUpdateLocation
            minHeight="min-h-[50%]"
            state={modalCreateUpdate}
            dropDownProvince={dropDownProvince}
            onClose={() => setModalCreateUpdate({ ...modalCreateUpdate, show: false })}
            onSubmit={(values) => {
              setIsLoadingCRUD(true)
              const mount = setTimeout(async () => {
                if (modalCreateUpdate.type === 'create') {
                  await apiPost({
                    url: `${urls.master.prefix}/${urls.master.location.all.root}`,
                    data: {
                      name: values.kelurahan,
                      subdistrict_id: parseInt(values.subDistrictSelector),
                      postal_code: values.postalCode
                    },
                    token: user.token,
                    onLogout
                  })
                }
                if (modalCreateUpdate.type === 'update') {
                  await apiPut({
                    url: `${urls.master.prefix}/${urls.master.location.all.root}/${modalCreateUpdate.id}`,
                    data: {
                      name: values.kelurahan,
                      subdistrict_id: parseInt(values.subDistrictSelector),
                      postal_code: values.postalCode
                    },
                    token: user.token,
                    onLogout
                  })
                }
                setModalCreateUpdate({ ...modalCreateUpdate, show: false })
                setIsLoadingCRUD(false)
                refetch()
              })
              return () => clearTimeout(mount)
            }}
          />
        ) : null}
        {modalDelete.show ? (
          <ModalDelete
            minHeight="min-h-[22%]"
            maxWidth="max-w-[25%]"
            title={modalDelete.title}
            desc={modalDelete.desc}
            onClose={() => setModalDelete({ ...modalDelete, show: false })}
            onSubmit={() => {
              setIsLoadingCRUD(true)
              const mount = setTimeout(async () => {
                await apiDelete({
                  url: `${urls.master.prefix}/${urls.master.location.all.root}/${modalDelete.locationId}`,
                  token: user.token,
                  onLogout
                })
                setModalDelete({ ...modalDelete, show: false })
                refetch()
                setIsLoadingCRUD(false)
              })
              return () => clearTimeout(mount)
            }}
          />
        ) : null}
        <CardContainer>
          <div className="flex flex-col w-full space-y-5">
            <HeaderContainer
              isPressAdd
              title="Lokasi Lengkap"
              titleAdd="Tambah Lokasi"
              onPressAdd={() =>
                setModalCreateUpdate({
                  show: true,
                  type: 'create',
                  id: 0,
                  name: '',
                  postalCode: '',
                  provinceId: 0,
                  cityId: 0,
                  subDistrictId: 0
                })
              }
            />

            <div className="flex flex-row w-full mt-2">
              <div className="flex flex-row w-full space-x-5">
                <div className="w-1/5">
                  <Formik
                    enableReinitialize
                    initialValues={{
                      provinceSelector: provinceSelected
                    }}>
                    <FormDropDown
                      isSearch
                      allowClear
                      placeholder="Semua Provinsi"
                      name="provinceSelector"
                      data={dropDownProvince}
                      onChange={(value) => {
                        setIsLoadingCRUD(true)
                        setDropDownCity([])
                        let extraUrl = ''
                        if (value && parseInt(value) > 0) {
                          extraUrl += `&province_id=${parseInt(value)}`
                        }
                        if (citySelected > 0) {
                          extraUrl += `&city_id=${citySelected}`
                        }
                        if (subDistrictSelected > 0) {
                          extraUrl += `&subdistrict_id=${subDistrictSelected}`
                        }
                        if (locationSearch) {
                          extraUrl += `&keywords=${locationSearch}`
                        }
                        const mount = setTimeout(async () => {
                          const response = await Promise.all([
                            apiGet({
                              url: `${urls.master.prefix}/${urls.master.location.all.root}?limit=${
                                perPageArr.find((item) => item.selected === true).value
                              }&offset=0${extraUrl}`,
                              token: user.token,
                              onLogout
                            }),
                            apiGet({
                              url: `${urls.master.prefix}/${
                                urls.master.location.cities.filterByProvince
                              }/${value && parseInt(value) > 0 ? parseInt(value) : ''}`,
                              token: user.token,
                              onLogout
                            })
                          ])

                          if (response[0].resStatus === 200) {
                            setListLocations(response[0].resData.data)
                            setMeta(response[0].resData.meta)
                          } else {
                            refetch()
                          }
                          if (response[1].resStatus === 200) {
                            if (response[1].resData.data.length !== 0) {
                              response[1].resData.data.map((item) => {
                                setDropDownCity((prev) => [
                                  ...prev,
                                  { name: item.name, value: item.id }
                                ])
                              })
                            }
                          }
                          setProvinceSelected(value ? parseInt(value) : null)
                          setIsLoadingCRUD(false)
                        })
                        return () => clearTimeout(mount)
                      }}
                    />
                  </Formik>
                </div>
                <div className="w-1/5">
                  <Formik
                    enableReinitialize
                    initialValues={{
                      citySelector: citySelected
                    }}>
                    <FormDropDown
                      isSearch
                      allowClear
                      placeholder="Semua Kota/Kabupaten"
                      name="citySelector"
                      data={dropDownCity}
                      onChange={(value) => {
                        setDropDownSubDistrict([])
                        setIsLoadingCRUD(true)
                        let extraUrl = ''
                        if (value && parseInt(value) > 0) {
                          extraUrl += `&city_id=${parseInt(value)}`
                        }
                        if (provinceSelected > 0) {
                          extraUrl += `&province_id=${provinceSelected}`
                        }
                        if (subDistrictSelected > 0) {
                          extraUrl += `&subdistrict_id=${subDistrictSelected}`
                        }
                        if (locationSearch) {
                          extraUrl += `&keywords=${locationSearch}`
                        }
                        const mount = setTimeout(async () => {
                          const response = await Promise.all([
                            apiGet({
                              url: `${urls.master.prefix}/${urls.master.location.all.root}?limit=${
                                perPageArr.find((item) => item.selected === true).value
                              }&offset=0${extraUrl}`,
                              token: user.token,
                              onLogout
                            }),
                            apiGet({
                              url: `${urls.master.prefix}/${
                                urls.master.location.subDistrict.filterByCity
                              }/${value && parseInt(value) > 0 ? parseInt(value) : ''}`,
                              token: user.token,
                              onLogout
                            })
                          ])

                          if (response[0].resStatus === 200) {
                            setListLocations(response[0].resData.data)
                            setMeta(response[0].resData.meta)
                          } else {
                            refetch()
                          }
                          if (response[1].resStatus === 200) {
                            if (response[1].resData.data.length !== 0) {
                              response[1].resData.data.map((item) => {
                                setDropDownSubDistrict((prev) => [
                                  ...prev,
                                  { name: item.name, value: item.id }
                                ])
                              })
                            }
                          }
                          setCitySelected(value ? parseInt(value) : null)
                          setIsLoadingCRUD(false)
                        })
                        return () => clearTimeout(mount)
                      }}
                    />
                  </Formik>
                </div>
                <div className="w-1/5">
                  <Formik
                    enableReinitialize
                    initialValues={{
                      subDistrictSelector: subDistrictSelected
                    }}>
                    <FormDropDown
                      isSearch
                      allowClear
                      placeholder="Semua Kecamatan"
                      name="subDistrictSelector"
                      data={dropDownSubDistrict}
                      onChange={(value) => {
                        setIsLoadingCRUD(true)
                        let extraUrl = ''
                        if (value && parseInt(value) > 0) {
                          extraUrl += `&subdistrict_id=${parseInt(value)}`
                        }
                        if (provinceSelected > 0) {
                          extraUrl += `&province_id=${provinceSelected}`
                        }
                        if (citySelected > 0) {
                          extraUrl += `&city_id=${citySelected}`
                        }
                        if (locationSearch) {
                          extraUrl += `&keywords=${locationSearch}`
                        }
                        const mount = setTimeout(async () => {
                          const response = await apiGet({
                            url: `${urls.master.prefix}/${urls.master.location.all.root}?limit=${
                              perPageArr.find((item) => item.selected === true).value
                            }&offset=0${extraUrl}`,
                            token: user.token,
                            onLogout
                          })
                          if (response.resStatus === 200) {
                            setListLocations(response.resData.data)
                            setMeta(response.resData.meta)
                          } else {
                            refetch()
                          }
                          setSubDistrictSelected(value ? parseInt(value) : null)
                          setIsLoadingCRUD(false)
                        })
                        return () => clearTimeout(mount)
                      }}
                    />
                  </Formik>
                </div>
              </div>
              <div className="flex-row w-1/4">
                <Formik
                  initialValues={{
                    locationSearch: locationSearch
                  }}>
                  <FormInput
                    name="locationSearch"
                    placeholder="Pencarian"
                    type="text"
                    isIconLeft
                    iconName="search"
                    onValidate={async (value) => {
                      let extraUrl = ''
                      if (provinceSelected > 0) {
                        extraUrl += `&province_id=${provinceSelected}`
                      }
                      if (citySelected > 0) {
                        extraUrl += `&city_id=${citySelected}`
                      }
                      if (subDistrictSelected > 0) {
                        extraUrl += `&subdistrict_id=${subDistrictSelected}`
                      }
                      const response = await apiGet({
                        url: `${urls.master.prefix}/${
                          urls.master.location.all.root
                        }?keywords=${value}&limit=${
                          perPageArr.find((item) => item.selected === true).value
                        }&offset=0${extraUrl}`,
                        token: user.token,
                        onLogout
                      })
                      if (response.resStatus === 200) {
                        setListLocations(response.resData.data)
                        setMeta(response.resData.meta)
                      } else {
                        refetch()
                      }
                      setLocationSearch(value)
                    }}
                  />
                </Formik>
              </div>
            </div>
            <Table
              currentPage={meta.offset ? meta.offset + 1 : 1}
              totalPerPage={
                perPageArr.find((item) => item.selected === true).value + (meta.offset ?? 0) >
                meta.total
                  ? meta.total
                  : perPageArr.find((item) => item.selected === true).value + (meta.offset ?? 0)
              }
              dropDownDataFilter={perPageArr}
              lengthAllData={meta.total}
              columns={columns}
              data={listLocations}
              onChangePrevPage={() => {
                if (currentPage > 0) {
                  setCurrentPage(currentPage - 1)
                  onChangePrevNextPage(
                    (currentPage - 1) * perPageArr.find((item) => item.selected === true).value
                  )
                }
              }}
              onChangeNextPage={() => {
                if (
                  perPageArr.find((item) => item.selected === true).value + (meta.offset ?? 0) <
                  meta.total
                ) {
                  setCurrentPage(currentPage + 1)
                  onChangePrevNextPage(
                    (currentPage + 1) * perPageArr.find((item) => item.selected === true).value
                  )
                }
              }}
              onChangeDropDown={(value) => onChangePerPage(value)}
            />
          </div>
        </CardContainer>
      </Content>
    </Layout>
  )
}

export default LocationPage
